<template lang="pug">
div
  .md-form-group
    label Search
    input(
      type="text"
      name="search"
      v-model="search"
      class="form-control"
      @input="onFiltersChange"
    )

  .md-form-group
    label Include Label
    multiselect(
      :loading="onLoading('fetch-label')"
      name="labels"
      deselect-label=""
      label="name"
      select-label=""
      track-by="id"
      v-model="label"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="includeLabelList"
      @input="onFiltersChange"
    )
      template(slot="option", slot-scope="props")
        label-badge(
            :labelName="props.option.name"
            :backgroundColor="props.option.color"
        )

  .m-b-1(
    v-for="lbl in label"
  ) 
    label-badge(
        :labelName="lbl.name" 
        :backgroundColor="lbl.color" 
        :key="lbl.id"
    )

  .md-form-group
    label Exclude Label
    multiselect(
      :loading="onLoading('fetch-label')"
      name="exclude-labels"
      track-by="id"
      label="name"
      select-label=""
      deselect-label=""
      v-model="excludeLabels"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="excludeLabelList"
      @input="onFiltersChange"
    )
      template(slot="option", slot-scope="props")
        label-badge(
            :labelName="props.option.name"
            :backgroundColor="props.option.color"
        )

  .m-b-1(
    v-for="lbl in excludeLabels"
  ) 
    label-badge(
        :labelName="lbl.name" 
        :backgroundColor="lbl.color" 
        :key="lbl.id"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import LabelMixin from '@js/mixins/label';
import LabelBadge from '@js/components/label/label-badge';

export default {
    components: {
        LabelBadge,
    },

    mixins: [LabelMixin],

    props: {
        updateFilters: {
            type: Function,
            required: true,
        },
        onAddAllChange: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            addAll: false,
            label: [],
            search: null,
            excludeLabels: [],
        };
    },

    computed: {
        ...mapGetters('label', ['labels']),

        excludeLabelList() {
            return _.difference(this.labels, this.label);
        },

        includeLabelList() {
            return _.difference(this.labels, this.excludeLabels);
        },
    },

    created() {
        this.getLabelListIfNecessary();

        this.$on('reset-filters', filters => {
            this.reset(filters);
        });
    },

    methods: {
        onFiltersChange: _.debounce(function(query) {
            this.updateFilters({
                label: this.label,
                excludeLabel: this.excludeLabels,
                search: this.search,
            });
        }, 500),

        reset(filters) {
            this.label = filters.label;
            this.excludeLabels = filters.excludeLabel;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/template/station-filter-sidebar.vue